<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<div class="title-acknowPage"><a href="#/e9781429977456_toc01#toctitle1" id="title1"><span><strong class="b">ACKNOWLEDGMENTS</strong></span></a></div>
<div class="p"><span>Sincere thanks to Gene Roddenberry and the show’s writers, producers, and brilliant cast for creating such a terrific canvas. Thanks also to Jim Frenkel—it’s been a long time coming, hasn’t it? And deepest appreciation to Cindy, Tara, Howard, Erin, and the gang. And Maryelizabeth, of course, for giving me the space and time to write about time and space.</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429977456_ack01.vue?5cd6c750